import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { ConsorsSchufaInfoTableDefinitionZod } from '../tables';

type Arguments = {
    applicantId: string;
    id: string;
    position?: number;
};
export const schemaLoanRequestResolver_GetSchufa = ConsorsSchufaInfoTableDefinitionZod.nullable();

export type SchemaLoanRequestResolver_GetSchufa = z.infer<typeof schemaLoanRequestResolver_GetSchufa>;

export type LoanRequestResolver_GetSchufa = Resolver<Arguments, SchemaLoanRequestResolver_GetSchufa>;
